import {
    BoxProps,
    Flex,
  } from "@chakra-ui/react";
  import { useGamCampaignInfo } from ".";
  import { DetailField } from "../../components/detailField/DetailField";

  export const TargetDetailsSummary = (props: BoxProps) => {
    const { gamCampaign } = useGamCampaignInfo();

    return (
      // <SectionBox {...props}>
        <Flex direction={"column"} {...props}>
            {gamCampaign.externalId && (
                <DetailField
                    label={"ID:"}
                    value={gamCampaign.externalId}
                    isCopyField={true}
                    variant={"flex"}
                />
            )}
            {gamCampaign.orderId && (
                <DetailField
                    label={"Order ID:"}
                    value={gamCampaign.orderId}
                    isCopyField={true}
                    variant={"flex"}
                />
            )}
            {gamCampaign.learnFromIds && (
                <DetailField
                    label={"Learn From ID:"}
                    value={gamCampaign.learnFromIds}
                    isCopyField={true}
                    variant={"flex"}
                />
            )}
        </Flex>
      // </SectionBox>
    );
  };
